const { windowLoaded } = await import(`./modules/general.js?ver=${paths.cachebuster}`);
const { initMenu } = await import(`./modules/menu.js?ver=${paths.cachebuster}`);
const { initBuilder, buildToCFromHeaders } = await import(
  `./modules/builder.js?ver=${paths.cachebuster}`
);
const { manageHubSpotForm } = await import(`./modules/hubspot_form.js?ver=${paths.cachebuster}`);

async function main() {
  await windowLoaded();

  try {
    initMenu();
    initBuilder();
    manageHubSpotForm();
    buildToCFromHeaders();
  } catch (err) {
    console.error(err);
  }
}

main();
